import { useCallback, useMemo } from "react";
import { ImageCell, LongTextCell, tableHooks } from "components/Table";
import { MenuCell, PriorityCell, StatusCell } from '..'
import { ReactComponent as GoIcon } from 'assets/icons/Go.svg';
import { useNavigate } from "react-router-dom";
import { app } from "router/routes";
import { useDispatch } from "react-redux";
import { currentDateTime } from "utils/formatter";
import { SvgIcon, Tooltip, IconButton } from "@mui/material";

const useColumns = () => {
    const idCell = tableHooks.useIdCell()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const goTicketMessage = useCallback(({ id }) => {
        navigate(`${app.tickets}/${id}`)
    }, [])

    const columns = useMemo(
        () => [
            {
                accessorKey: 'status',
                header: "סטטוס",
                cell: StatusCell
            },
            {
                accessorKey: 'priority',
                header: "קדימות",
                cell: PriorityCell,
                feature: "ticket-priority",
                role: "read"
            },
            {
                accessorKey: "created_by_name",
                header: "שם משתמש"
            },
            {
                accessorKey: 'title',
                header: "כותרת ההודעה",
            },
            {
                accessorKey: 'description',
                header: "תוכן ההודעה",
                cell: LongTextCell
            },
            {
                accessorKey: 'last_message_content',
                header: "תוכן ההודעה האחרונה",
                cell: LongTextCell,
                meta: {
                    showCreatedBy: true
                }
            },
            {
                accessorKey: 'update_date',
                header: "עודכן לאחרונה",
                cell: info => `${currentDateTime(info.getValue()) || ""}`,
            },
            {
                accessorKey: 'last_message_create_date',
                header: "הודעה אחרונה",
                cell: info => `${currentDateTime(info.getValue()) || ""}`,
            },
            {
                accessorKey: 'last_message_image_url',
                header: "תמונה",
                cell: ImageCell
            },
            {
                accessorKey: 'go_ticket_message',
                header: "כניסה",
                enableSorting: false,
                cell: ({ row }) => {

                    return (
                        <Tooltip key={row.id} tooltip="לכניסה" placement="left">
                            <IconButton
                                // className="transparent-icon"
                                onClick={() => {
                                    goTicketMessage(row.original)
                                }}
                            >
                                <SvgIcon component={GoIcon} inheritViewBox />
                            </IconButton>
                        </Tooltip>
                    );
                }
            },
            {
                accessorKey: 'id',
                header: "",
                enableSorting: false,
                feature: "ticket-menu",
                role: "read",
                cell: MenuCell,
            }
        ], []
    )

    return columns
}

export default useColumns